import React from 'react'

// styles
import { moreOptionsButton, moreOptionDot } from './styles'

export const MoreOptionsButton: React.FC = () => {
  return (
    <div className={moreOptionsButton}>
      <div className={moreOptionDot}></div>
      <div className={moreOptionDot}></div>
      <div className={moreOptionDot}></div>
    </div>
  )
}
